import {useMutation, UseMutationOptions} from '@tanstack/react-query';
import {api} from 'api/setup';
import {VoucherType} from 'types';

type PromoValidityParams = {
  promoCode: string;
  providerId: string;
  cartTotal: number;
};

export const useCheckPromoValidityMutation = (
  options?: UseMutationOptions<VoucherType, unknown, {promoCode: string}>,
) => {
  return useMutation<any, VoucherType, any, any>({
    mutationFn: ({promoCode, providerId, cartTotal}: PromoValidityParams) =>
      api.post('/check-promo-code/validity', {
        promo_code: promoCode,
        provider_id: providerId,
        cart_total: cartTotal,
      }),
    ...options,
  });
};
